import React from 'react';

import { ExternalLink } from '../../Clickables/ExternalLink/ExternalLink';
import { Text } from '../../Text/Text';

export const CancellationText = ({ className = '' }: { className?: string }) => (
  <div className={`mt-4 mb-6 flex text-center ${className}`}>
    <Text variant="sm" className="m-0">
      Recurring billing,{' '}
      <ExternalLink
        href="https://fishbrain.helpshift.com/hc/en/3-fishbrain---social-fishing-forecast-app/faq/180-how-do-i-cancel-my-web-subscription/"
        variant="textNone"
        target="_blank"
        className="underline"
      >
        cancel
      </ExternalLink>{' '}
      anytime
    </Text>
  </div>
);
